import { render, staticRenderFns } from "./SectionExCourceDetail.vue?vue&type=template&id=6b7704dd&scoped=true&"
import script from "./SectionExCourceDetail.vue?vue&type=script&lang=js&"
export * from "./SectionExCourceDetail.vue?vue&type=script&lang=js&"
import style0 from "./SectionExCourceDetail.vue?vue&type=style&index=0&id=6b7704dd&scoped=true&lang=css&"
import style1 from "./SectionExCourceDetail.vue?vue&type=style&index=1&id=6b7704dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7704dd",
  null
  
)

export default component.exports